<template>
  <div class="product-donate-type-wrapper" v-if="product && allowedMonthly">
    <div class="product-donate-type">
      <div class="donate-type-item">
        <div class="control">
          <input type="radio" name="donate_type" v-model="type" value="onetime"/>
          <label class="label label--left onetime">รายครั้ง</label>
        </div>
      </div>
      <div class="donate-type-item">
        <div class="control">
          <input type="radio" name="donate_type" v-model="type" value="monthly"/>
          <label class="label label--right monthly">รายเดือน</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ProductDonateType',

    props: {
      product: {
        type: Object,
        default: null
      },
      value: {
        type: String,
        default: 'monthly'
      }
    },

    data () {
      return {
        type: this.value
      }
    },

    computed: {
      allowedMonthly () {
        const productAllows = this.product.meta.$donation_allow_recurring_donation === true || this.product.meta.$donation_allow_recurring_donation === 'true'
        return productAllows && this.$utils.isMonthlyOptionAllowed()
      }
    },

    watch: {
      type: function (newValue) {
        this.$emit('input', newValue)
      },
      value: function (newValue) {
        this.type = newValue
      }
    }
  }
</script>

<style scoped lang="scss">
  .product-donate-type-wrapper {
    margin-bottom: 20px;

    .product-donate-type {
      display: flex;
      display: -webkit-flex;
      background: #CEE0F7;
      border-radius: 50px;
      padding: 0;

      .donate-type-item {
        flex: 1;
        font-weight: 400;
        font-size: 1.1em;
      }
    }

    .control {
      position: relative;

      .label {
        color: #1E416D;
        background: transparent;
        min-height: 50px;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border: none;
        border-radius: 50px;
        cursor: pointer;
        transition: background 0.2s, color 0.2s;
        margin-bottom: 0;
      }

      input[type="radio"] {
        cursor: pointer;
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 999;
        opacity: 0;

        &:checked + .label {
          background: #1E416D;
          color: #fff;
          box-shadow: 0 2px 8px rgba(0, 0, 0, .18);
          font-weight: bold;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ProductDonateType.vue?4db007b8